Revolution.Module.extend({
    NAME: "mde.bk-filters-search", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        $('body').on('click', '.ul-filters li button', this.activeFilterSearch);
        this.initDisableTab();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    activeFilterSearch: function (e) {
        var $obj = $(e.currentTarget);
        var $ulFilters = $obj.parents('.ul-filters');
        var $contentForm = $obj.parents('.bk-filters-search').find('.form-filters-wrapper');
        var index = $obj.parents('li').index();

        $ulFilters.find('li button').attr('aria-expanded', 'false').removeAttr('aria-current');
        $contentForm.removeClass('active');
        $contentForm.find('input, select, textarea, a, button').attr('tabindex', '-1');

        $contentForm.eq(index).addClass('active').attr('aria-hidden', 'false');
        $contentForm.eq(index).find('input, select, textarea, a, button').attr('tabindex', '');


        if ($obj.hasClass('active')) {
            $obj.removeClass('active');
            $contentForm.eq(index).removeClass('active');
        } else {
            $contentForm.eq(index).addClass('active');
            $ulFilters.find('li button').removeClass('active');
            $obj.addClass('active').attr('aria-current', 'true');
            $obj.attr('aria-expanded', 'true');
        }
    },
    initDisableTab: function (e) {
        var $contentForm = $('.bk-filters-search .form-filters-wrapper');

        if ($contentForm.length) {
            $contentForm.find('input, select, textarea, a, button').attr('tabindex', '-1');
        }
    }
});
